import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  Show,
  SimpleShowLayout,
  EditButton,
  ShowButton,
  DeleteWithConfirmButton,
  TopToolbar,
  ExportButton,
  ReferenceField,
} from 'react-admin';

const CarListActions = () => (
  <TopToolbar>
    <ExportButton />
  </TopToolbar>
);

export const CarList = () => (
  <List actions={<CarListActions />}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="manufacturer" />
      <TextField source="model" />
      <TextField source="year" />
      <TextField source="licensePlate" />
      <TextField source="plateCountry" />
      <ReferenceField source="userId" reference="users">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <ShowButton />
      <EditButton />
      <DeleteWithConfirmButton />
    </Datagrid>
  </List>
);

export const CarEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="manufacturer" />
      <TextInput source="model" />
      <NumberInput source="year" />
      <TextInput source="licensePlate" />
      <TextInput source="plateCountry" />
      <TextInput source="color" />
      <TextInput source="vin" />
    </SimpleForm>
  </Edit>
);

export const CarShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="manufacturer" />
      <TextField source="model" />
      <TextField source="year" />
      <TextField source="licensePlate" />
      <TextField source="plateCountry" />
      <TextField source="color" />
      <TextField source="vin" />
      <ReferenceField source="userId" reference="users">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
